import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=01e778b1&"
import script from "./StaffManagement.vue?vue&type=script&lang=js&"
export * from "./StaffManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports